<template>
  <div class="member-info-skeleton">
    <div class="d-flex flex-wrap" style="gap: 40px;">
      <Skeleton width="100px" height="100px" />
      <div class="d-flex flex-column justify-content-start">
        <div class="d-flex align-items-center mb-3">
          <span class="d-block mr-2 font-weight-bold font-size-18">Login:</span>
          <Skeleton width="100px" height="20px" />
        </div>
        <div class="d-flex align-items-center">
          <a-icon type="link" class="mr-2" /> <Skeleton width="300px" height="18px" />
        </div>
      </div>
    </div>
    <div class="mt-3">
      <FormSubTitle title="Info" />
      <div class="d-flex flex-wrap" style="gap: 20px;">
        <InfoBlock :loading="true" />
        <InfoBlock :loading="true" />
        <InfoBlock :loading="true" />
      </div>
    </div>
    <div class="d-flex flex-wrap mt-3" style="gap: 200px;">
      <div class="w-full" style="max-width: 500px;">
        <FormSubTitle title="Conditions" />
        <div class="d-flex flex-column w-full" style="gap: 20px;">
          <div v-for="n in 4" :key="n" class="conditions">
            <div class="d-flex flex-column" style="gap: 5px;">
              <Skeleton width="100px" height="16px" />
              <Skeleton width="200px" height="16px" />
            </div>
          </div>
        </div>
      </div>
      <div>
        <FormSubTitle title="Cashback settings" />
        <SemicircleDiagram />
        <div class="d-flex align-items-center flex-column">
          <Skeleton width="200px" height="16px" class="mb-1" />
          <Skeleton width="200px" height="16px" />
        </div>
        <div class="d-flex mt-3" style="gap: 20px;">
          <div class="block">
            <span class="text-default font-weight-bold">Percentage</span>
            <Skeleton width="80px" height="16px" />
          </div>
          <div class="block">
            <span class="text-default font-weight-bold">Percentage</span>
            <Skeleton width="80px" height="16px" />
          </div>
        </div>
      </div>
    </div>
    <div class="mt-5">
      <Skeleton width="100px" height="16px" class="mb-3" />
      <div class="table">
        <div class="table__head">
          <Skeleton width="80px" height="18px" />
          <Skeleton width="80px" height="18px" />
          <Skeleton width="80px" height="18px" />
          <Skeleton width="80px" height="18px" />
          <Skeleton width="80px" height="18px" />
          <Skeleton width="80px" height="18px" />
          <Skeleton width="80px" height="18px" />
        </div>
        <div class="table__row" v-for="n in 5" :key="n">
          <Skeleton :width="n % 2 === 0 ? '80px' : '120px'" height="16px" />
          <Skeleton :width="n % 2 === 0 ? '80px' : '120px'" height="16px" />
          <Skeleton :width="n % 2 === 0 ? '80px' : '120px'" height="16px" />
          <Skeleton :width="n % 2 === 0 ? '80px' : '120px'" height="16px" />
          <Skeleton :width="n % 2 === 0 ? '80px' : '120px'" height="16px" />
          <Skeleton :width="n % 2 === 0 ? '80px' : '120px'" height="16px" />
          <Skeleton :width="n % 2 === 0 ? '80px' : '120px'" height="16px" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Skeleton from '@/components/custom/skeleton/Skeleton.vue'
import FormSubTitle from '@/components/custom/form/FormSubTitle.vue'
import InfoBlock from './InfoBlock.vue'
import SemicircleDiagram from '@/views/apps/referral-program/components/SemicircleDiagram.vue'

export default {
  components: {
    Skeleton,
    FormSubTitle,
    InfoBlock,
    SemicircleDiagram,
  },
}
</script>

<style lang="scss">
.member-info-skeleton {
  .conditions {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    padding: 20px;
    border: 1px solid #e4e9f0;
    border-radius: 5px;
    background-color: #fff;
  }
  .block {
    padding: 10px 20px;
    border: 1px solid #e4e9f0;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    width: fit-content;
    transition: all .3s ease;
  }
  .table {
    &__head {
      border: 1px solid #f0f2f4;
      padding: 16px;
      display: flex;
      justify-content: space-between;
    }
    &__row {
      padding: 16px;
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>
